export const SUBJECTS_STEP_ID = "subjects";
export const SUBJECTS_STEP_TITLE = "Add Subjects";
